module.exports = __webpack_public_path__ + "media/vr-environment_1_1.8a1590f7.mp4";